import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Modal,
  Row,
  Select,
  Typography,
} from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import "./SellerChooseVehicleModal.css";
import ChooseAddressModal from "./SellerChooseAddressModal/SellerChooseAddressModal";
import SellerVehicleRequest from "./SellerVechicleRequest/SellerVehicleRequest";
import { ReactComponent as Alert1Icon } from "../../../../../../assets/seller/icons/porter_alert1.svg";
import { ReactComponent as Alert2Icon } from "../../../../../../assets/seller/icons/porter_alert2.svg";
import { ReactComponent as Alert3Icon } from "../../../../../../assets/seller/icons/porter_alert3.svg";
import { ReactComponent as Alert4Icon } from "../../../../../../assets/seller/icons/porter_alert4.svg";
import { ReactComponent as VehicleAlertIcon } from "../../../../../../assets/seller/icons/vehicle_alert.svg";
import { ReactComponent as MobDeliveryIcon } from "../../../../../../assets/icons/delivery-qwik-icon.svg";
import { ReactComponent as ClockIcon } from "../../../../../../assets/icons/icon-clock-1.svg";
import { ReactComponent as QwikIcon } from "../../../../../../assets/icons/qwik-icon.svg";
import { ReactComponent as QwikDelivery } from "../../../../../../assets/icons/4hrsdelivery.svg";

// import { TimeDropdownData as DeliverySlotOptions } from "../../../../../ManageOrders/OrderDetails/OrderConstant/Constant";

const { Text } = Typography;

const SellerChooseVehicleModal = ({
  isModalOpen,
  setIsModalOpen,
  handleOk,
  vendorAddressData,
  pickupAddressValue,
  setPickupAddressValue,
  vendorAddressapiSuccess,
  updateOrderStatusLoading,
  DeliveryDateValue,
  SelectedTime,
  setDeliveryDateValue,
  setSelectedTime,
  vehiclesmaster,
  addVehicleFormData,
  setAddVehicleFormData,
  schedule_choices_list,
  logisticsChannel,
  setLogisticsChannel,
  pickupTime,
  setPickupTime,
  orderType,
}) => {
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  const [isMobileView, setIsMobileView] = useState(getIsMobileView);
  const [deliveryConfirmed, setDeliveryConfirmed] = useState(false);
  const [pickupAddressModal, setPickupAddressModal] = useState(false);
  const [value, setValue] = useState();
  // const [deliveryDateTouched, setDeliveryDateTouched] = useState(false);

  const calculatePickupTime = (timeKey) => {
    const now = new Date();
    let minutes = 0;

    // Parse the time key to extract hours and minutes
    const match = timeKey?.match(/(\d+)s|(\d+)m|(\d+)h(\d+)?m?/g);

    if (match) {
      match.forEach((part) => {
        if (part.includes("s")) {
          const seconds = parseInt(part);
          minutes += seconds / 60;
        } else if (part.includes("h") && part.includes("m")) {
          const [hours, mins] = part.split("h");
          minutes += parseInt(hours) * 60 + parseInt(mins.replace("m", ""));
        } else if (part.includes("h")) {
          minutes += parseInt(part) * 60;
        } else if (part.includes("m")) {
          minutes += parseInt(part);
        }
      });
    }

    const futureTime = new Date(now.getTime() + minutes * 60000);
    const hours = futureTime.getHours();
    const mins = futureTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12;
    const displayMins = mins < 10 ? `0${mins}` : mins;

    return `${displayHours}:${displayMins} ${ampm}`;
  };

  const handleCancel = () => {
    setValue();
    setIsModalOpen(false);
    setDeliveryConfirmed(false);
    // setDeliveryDateTouched(false);
    setLogisticsChannel("DEFAULT");
    setPickupAddressValue({});
    setAddVehicleFormData();
    setPickupTime(undefined);
    const newId =
      addVehicleFormData.length > 0
        ? addVehicleFormData[addVehicleFormData.length - 1].id + 1
        : 1;
    const newVehicle = {
      id: newId,
      vechicle_type: "SELECT VEHICLE",
      vechicle_type_Id: 0,
      quantity: 1,
      vechicle_image: "",
      vechicle_weight: "",
      vechicle_storage: "",
      vehicleVisible: "",
    };
    setAddVehicleFormData([newVehicle]);
  };
  const handleAddressChange = () => {
    setPickupAddressModal(true);
  };

  useEffect(() => {
    if (vendorAddressData?.data) {
      setPickupAddressValue(vendorAddressData?.data[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorAddressData, vendorAddressapiSuccess]);

  // Reset pickupTime when modal closes
  useEffect(() => {
    if (!isModalOpen) {
      setPickupTime(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  useEffect(() => {
    setDeliveryConfirmed(false);
  }, [logisticsChannel]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(getIsMobileView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const normalizedOrderType = String(orderType || "").toUpperCase();
  const isQwikOrder =
    normalizedOrderType === "QWIK" || normalizedOrderType === "QUICK_ORDER";
  const isManualSelection =
    logisticsChannel?.startsWith("YOUR") ||
    logisticsChannel?.startsWith("MANUAL");
  const isMobSelection = logisticsChannel?.startsWith("MOB");
  const isChannelSelected = isManualSelection || isMobSelection;

  const handlePickupTimeChange = (selectedValue) => {
    setPickupTime(selectedValue);
    const selectedOption = schedule_choices_list?.find(
      (item) => item.key === selectedValue
    );
    setSelectedTime(selectedOption?.label || selectedValue || "");
  };
  // const handleDeliveryDateChange = (date) => {
  //   setDeliveryDateValue(date);
  //   setDeliveryDateTouched(!!date);
  // };
  // const handleDeliverySlotChange = (value) => {
  //   setSelectedTime(value);
  // };

  const logisticsChannelOptions = isQwikOrder
    ? [
        {
          value: "DEFAULT",
          label: "Select your logistics channel",
          disabled: true,
        },
        {
          value: "MOB_VEHICLE_LT_3H",
          label: "MOB vehicle - pickup LESS than 3hrs",
        },
        {
          value: "YOUR_VEHICLE_LT_3H",
          label: "Your vehicle - pickup LESS than 3hrs",
        },
      ]
    : [
        {
          value: "DEFAULT",
          label: "Select your logistics channel",
          disabled: true,
        },
        {
          value: "MOB_VEHICLE_LT_3H",
          label: "MOB vehicle - pickup LESS than 3hrs",
        },
        {
          value: "MOB_VEHICLE_GT_3H",
          label: "MOB vehicle - pickup MORE than 3hrs",
        },
        {
          value: "YOUR_VEHICLE_LT_3H",
          label: "Your vehicle - pickup LESS than 3hrs",
        },
        {
          value: "YOUR_VEHICLE_GT_3H",
          label: "Your vehicle - pickup MORE than 3hrs",
        },
      ];

  const footerContent = (
    <Col className={`addFile-wrapper ${isMobileView ? "choose-vehicle-mobile-footer" : ""}`}>
      <Button
        key="back"
        className="vehicle-cancel-btn"
        onClick={handleCancel}
      >
        CANCEL
      </Button>
      <Button
        key="submit"
        type="primary"
        className="vehicle-submit-btn"
        onClick={handleOk}
        disabled={
          !logisticsChannel ||
          logisticsChannel === "DEFAULT" ||
          !SelectedTime ||
          !pickupAddressValue?.id ||
          (isChannelSelected && !deliveryConfirmed)
        }
        loading={updateOrderStatusLoading}
      >
        ASSIGN AND ACCEPT ORDER
      </Button>
    </Col>
  );

  const bodyContent = (
    <Col
      style={{
        height: isMobileView ? "auto" : "530px",
        overflowY: isMobileView ? "visible" : "scroll",
      }}
    >
          {isQwikOrder && (
              <Col className="quick-strip-wrapper">
                <Col className="quick-strip-inner">
                  <QwikIcon />
                  <QwikDelivery />
                </Col>
              </Col>
            )}
          <Col className="modal-content-wrapper bg-modal-light">
            
            {/* Select logistics channel */}
            <Col className="vehicleassign-sections">
              <Text className="logistics-section-label">
               Select your logistics channel <span style={{color:"#f0483e"}}>*</span>
              </Text>
              <Select
                value={logisticsChannel}
                onChange={setLogisticsChannel}
                className="logistics-select"
                placeholder="Select your logistics channel"
                options={logisticsChannelOptions}
              />
            </Col>

            {/* Shared sections for selected logistics channel */}
            
              <>
                {/* Confirm pickup address */}
                <Col className="vehicleassign-sections">
                  <Row className="address-header-row">
                    <Text className="logistics-section-label">
                      Confirm your pickup address
                    </Text>
                    {vendorAddressData?.data?.length >= 1 && (
                      <Button
                        type="link"
                        className="address-change-btn"
                        onClick={handleAddressChange}
                      >
                        Change
                      </Button>
                    )}
                  </Row>
                  {vendorAddressData?.data &&
                  vendorAddressData?.data?.length ? (
                    <Row className="address-map-container">
                      <Col className="address-info-col">
                        <Text className="address-name">
                          {pickupAddressValue?.name ||
                            vendorAddressData?.data[0]?.name ||
                            ""}
                        </Text>
                        <Text className="address-details">
                          {pickupAddressValue?.address ||
                            vendorAddressData?.data[0]?.address ||
                            ""}
                          {pickupAddressValue?.address_line_2 ||
                          vendorAddressData?.data[0]?.address_line_2
                            ? ", "
                            : ""}
                          {pickupAddressValue?.address_line_2 ||
                            vendorAddressData?.data[0]?.address_line_2 ||
                            ""}
                        </Text>
                        <Text className="address-details">
                          {pickupAddressValue?.city ||
                            vendorAddressData?.data[0]?.city ||
                            ""}
                          {pickupAddressValue?.state ||
                          vendorAddressData?.data[0]?.state
                            ? ", "
                            : ""}
                          {pickupAddressValue?.state ||
                            vendorAddressData?.data[0]?.state ||
                            ""}
                          {pickupAddressValue?.pincode ||
                          vendorAddressData?.data[0]?.pincode
                            ? ", "
                            : ""}
                          {pickupAddressValue?.pincode ||
                            vendorAddressData?.data[0]?.pincode ||
                            ""}
                        </Text>
                        <Text className="address-contact">
                          Key Contact:{" "}
                          {pickupAddressValue?.contact_person ||
                            vendorAddressData?.data[0]?.contact_person ||
                            ""}
                        </Text>
                        <Text className="address-phone">
                          Ph no:{" "}
                          {pickupAddressValue?.phone_number ||
                            vendorAddressData?.data[0]?.phone_number ||
                            ""}
                        </Text>
                      </Col>
                      {/* <Col className="address-map-col">
                        <iframe
                          title="Pickup Location Map"
                          width="100%"
                          height="180"
                          frameBorder="0"
                          style={{ border: 0, borderRadius: "8px" }}
                          src={`https://www.google.com/maps?q=${
                            pickupAddressValue?.latitude ||
                            vendorAddressData?.data[0]?.latitude ||
                            0
                          },${
                            pickupAddressValue?.longitude ||
                            vendorAddressData?.data[0]?.longitude ||
                            0
                          }&output=embed`}
                          allowFullScreen
                        />
                      </Col> */}
                    </Row>
                  ) : (
                    <Text className="no-address-text">No Address Found</Text>
                  )}
                </Col>
                {/* <Col className="vehicleassign-sections">
                  <Text className="logistics-section-label">
                    Delivery date and time <span style={{ color: "#bf2600" }}>*</span>
                  </Text>
                  <Row>
                    <Col
                      className="dropdown-wrapper1"
                      style={{ width: "40%", marginRight: "10px" }}
                    >
                      <DatePicker
                        format={"DD-MMM-YYYY"}
                        style={{
                          height: "46px",
                          width: "100%",
                          borderRadius: "8px",
                          border: "solid 1px #bac7d5",
                          borderColor: deliveryDateTouched ? "#0a243f" : "#dedede",
                        }}
                        value={DeliveryDateValue || null}
                        onChange={handleDeliveryDateChange}
                      />
                    </Col>
                    <Col style={{ width: "57%" }}>
                      <Select
                        value={SelectedTime}
                        onChange={handleDeliverySlotChange}
                        className="pickup-time-select"
                        options={DeliverySlotOptions?.map((item) => ({
                          value: item.value,
                          label: `${item.label} ${item.time}`,
                        }))}
                      />
                    </Col>
                  </Row>
                </Col> */}
                {/* Pickup time */}
                {isQwikOrder && (
                  <Col className="vehicleassign-sections">
                    <Text className="logistics-section-label">Pickup time</Text>
                    <Row className="pickup-time-row">
                      <Col span={16} className="pickup-time-select-col">
                        <Select
                          value={pickupTime}
                          onChange={handlePickupTimeChange}
                          allowClear
                          className="pickup-time-select"
                          suffixIcon={
                            <ClockCircleOutlined className="clock-icon-warning" />
                          }
                          placeholder="Select pickup time"
                          options={schedule_choices_list?.map((item) => ({
                            value: item.key,
                            label: item.label,
                          }))}
                        />
                      </Col>
                      {pickupTime && (
                        <Col
                          span={7}
                          className="time-display-col pickup-time-at-col"
                        >
                          <ClockIcon className="clock-icon-margin" />
                          <Text>at {calculatePickupTime(pickupTime)}</Text>
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
              </>
            

            {/* Select vehicle - only show for MOB */}
            {isMobSelection && (
              <Col className="add-vehicle-type-request">
                <Text className="logistics-section-label" style={{padding:"16px"}}>Select vehicle</Text>
                <SellerVehicleRequest
                  vehiclesmaster={vehiclesmaster}
                  addVehicleFormData={addVehicleFormData}
                  setAddVehicleFormData={setAddVehicleFormData}
                />
                <Col className="static-sec-logistic">
                  <MobDeliveryIcon />
                  <Text className="logistics-section-label challan-text">
                    Please share only the MOB Delivery Challan and Invoice with
                    the driver at the time of dispatch.
                  </Text>
                </Col>
              </Col>
            )}

            {/* Manual assignment message - only show for Manual */}
            {isManualSelection && (
              <Col className="manual-assignment-container">
                <Col className="manual-icon-wrapper">
                  <VehicleAlertIcon />
                </Col>
                <Text className="manual-assignment-text">
                  Please assign your own vehicle
                </Text>
                <Col className="static-sec-logistic">
                  <MobDeliveryIcon />
                  <Text className="logistics-section-label challan-text">
                    Please share only the MOB Delivery Challan and Invoice with
                    the driver at the time of dispatch.
                  </Text>
                </Col>
              </Col>
            )}

            {/* Important notes - only show for MOB */}
            {isMobSelection && (
              <Col className="important-notes-box">
                <Col className="note-item">
                  <Text className="notes-title">
                    <Alert1Icon /> Important - penalty & terms
                  </Text>
                </Col>

                <Col className="note-item">
                  <Alert2Icon className="note-icon-danger" />
                  <Text className="note-text">
                   ₹99 (incl. tax) - for incorrect pickup address based cancellation
                  </Text>
                </Col>
                <Col className="note-item">
                  <Alert3Icon className="note-icon-danger" />
                  <Text className="note-text">
                   ₹99 (incl. tax) - for incorrect pickup vehicle selection led cancellation
                  </Text>
                </Col>
                <Col className="note-item-last">
                  <Alert4Icon className="note-icon-info" />
                  <Text className="note-text">
                   Loading beyond 30 mins of vehicle arrival may attract penalty
                  </Text>
                </Col>
              </Col>
            )}

            {/* Confirmation checkbox */}
            {isMobSelection && (
              <Col>
                <Checkbox
                  checked={deliveryConfirmed}
                  onChange={(e) => setDeliveryConfirmed(e.target.checked)}
                >
                  <Text className="checkbox-text">
                   I confirm the delivery address is correct and accept the penalty & terms
                  </Text>
                </Checkbox>
              </Col>
            )}
            {isManualSelection && (
              <Col>
                <Checkbox
                  checked={deliveryConfirmed}
                  onChange={(e) => setDeliveryConfirmed(e.target.checked)}
                >
                  <Text className="checkbox-text">
                    I understand that i will have to arrange the delivery for
                    this order
                  </Text>
                </Checkbox>
              </Col>
            )}
          </Col>
          <ChooseAddressModal
            setPickupAddressValue={setPickupAddressValue}
            isModalOpen={pickupAddressModal}
            setIsModalOpen={setPickupAddressModal}
            vendorAddressData={vendorAddressData}
            value={value}
            setValue={setValue}
          />
    </Col>
  );

  return (
    <>
      {isMobileView ? (
        <Drawer
          className="seller-choose-vehicle-mobile-drawer"
          wrapClassName="seller-choose-vehicle-mobile-drawer-wrap"
          placement="bottom"
          height="90vh"
          title="Assign vehicle for shipment"
          open={isModalOpen}
          onClose={handleCancel}
          bodyStyle={{ padding: 0 }}
          contentWrapperStyle={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            overflow: "hidden",
          }}
        >
          <div className="seller-choose-vehicle-drawer-body">
            <div className="seller-choose-vehicle-drawer-scroll">{bodyContent}</div>
            {footerContent}
          </div>
        </Drawer>
      ) : (
        <Modal
          style={{ top: "24px" }}
          title="Assign vehicle for shipment"
          open={isModalOpen}
          className="vehiclemodal"
          width={"610px"}
          onOk={handleCancel}
          onCancel={handleCancel}
          footer={footerContent}
        >
          {bodyContent}
        </Modal>
      )}
    </>
  );
};
export default SellerChooseVehicleModal;
